<template>
  <!--
 JobCellElementLite, multi-root, без q-chat-message / q-badge.
 DisplayType 5 (JobText) и 9 (JobStatus). Задача, заменить тяжёлые quasar-компоненты
    нативной разметкой 1:1 по визуалу.
  -->
  <template v-if="element.DisplayType === 5">
    <div
      v-for="(rec, i) in jobTextRows"
      :key="'jt_' + i"
      class="qtl-job-text"
    >
      <div
        v-for="(line, li) in rec.lines"
        :key="li"
        class="qtl-job-text__line"
        v-html="line"
      />
    </div>
  </template>

  <template v-else-if="element.DisplayType === 9">
    <div
      v-for="(rec, i) in jobStatusRows"
      :key="'js_' + i"
      class="qtl-job-status"
    >
      <span
        v-if="rec.mode === 1 || rec.mode === 3"
        class="qtl-job-status__badge"
        :style="{ backgroundColor: rec.color }"
      />
      <span
        v-if="rec.mode === 2 || rec.mode === 3"
        class="qtl-job-status__text"
      >{{ rec.text }}</span>
    </div>
  </template>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { JobStatus, TableDataCellDisplayType } from "@/models/etc/types";
import { i18n } from "@/i18n";
import { date as quasarDate } from "quasar";
import type {
  CellDataJobStatus,
  CellDataJobText,
  TableDataCell,
} from "@/models/interfaces/entity-settings/querytable/querytable";

const props = defineProps<{ element: TableDataCell }>();

const t = (k: string) => i18n.global.t(k);

interface JobTextRow { lines: string[]; }
interface JobStatusRow { text: string; color: string; mode: number; }

const jobTextRows = computed<JobTextRow[]>(() => {
  if (props.element.DisplayType !== TableDataCellDisplayType.JobText) return [];
  return (props.element.Data as CellDataJobText[]).map((cell) => {
    const lines: string[] = [];
    if (cell.Additions && cell.Additions.length) {
      cell.Additions.forEach((add: any) => {
        let text =
          cell.Text +
          "<br/>" +
          '<span style="color: green; font-weight: medium;">' +
          (add.Creator && add.Creator.Id ? " " + add.Creator.Name : "") +
          "</span>" +
          (add.Date
            ? ' <span style="color: green;">' +
              quasarDate.formatDate(new Date(add.Date), "HH:mm DD.MM.YYYY")
            : "") +
          "</span>" +
          '<br/><span style="font-weight: bold;">' +
          (add.Type ? t("job_status_work") : t("job_status_finished")) +
          "</span>" +
          (add.Message ? ": " + add.Message : "");
        lines.push(text);
      });
    } else {
      lines.push(cell.Text);
    }
    return { lines };
  });
});

const jobStatusRows = computed<JobStatusRow[]>(() => {
  if (props.element.DisplayType !== TableDataCellDisplayType.JobStatus) return [];
  return (props.element.Data as CellDataJobStatus[]).map((cell) => {
    switch (cell.Status) {
      case JobStatus.Standard:
        return { text: t("job_is_record"), color: "black", mode: cell.DisplayType };
      case JobStatus.Working:
        return { text: t("job_in_progress"), color: "blue", mode: cell.DisplayType };
      case JobStatus.WaitingForCheck:
        return { text: t("job_waiting"), color: "yellow", mode: cell.DisplayType };
      case JobStatus.Completed:
        return { text: t("job_done"), color: "green", mode: cell.DisplayType };
      case JobStatus.Lost:
      default:
        return { text: t("job_expired"), color: "red", mode: cell.DisplayType };
    }
  });
});
</script>

<style lang="scss" scoped>
.qtl-job-text {
  padding: 2px 0;
}

.qtl-job-text__line {
  font-size: 13px;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: normal;
}

.qtl-job-status {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 100%;
  gap: 4px;
  padding: 2px 4px;
}

.qtl-job-status__badge {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.qtl-job-status__text {
  font-size: 13px;
}
</style>
